import { Pipe, PipeTransform } from "@angular/core";
import { formatDistanceToNow } from "date-fns";

@Pipe({
  name: "formatRelativeDate",
})
export class FormatRelativeDatePipe implements PipeTransform {
  transform(date?: string | null): string {
    if (!date) return "N/A";
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
    });
  }
}
